import util from '@/libs/util'

//考评管理列表
export function companyEvaluationPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyEvaluation/page',
    params
  })
}

// 修改考评信息
export function companyEvaluationPut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyEvaluation',
    data
  })
}

// 删除考评信息
export function companyEvaluationDelete(params) {
  return util.http({
    method: 'delete',
    url: 'org/auth/companyEvaluation',
    params
  })
}

// 考评发布
export function companyEvaluationPublish(params) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyEvaluation/publish',
    params
  })
}

// 新增考评
export function companyEvaluationAdd(data) {
  return util.http({
    method: 'post',
    url: 'org/auth/companyEvaluation',
    data
  })
}

//考评职工列表
export function pageCompanyEvaluationEmployee(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyEvaluationEmployee/page',
    params
  })
}

//考评职工详情列表
export function companyEvaluationEmployeeRecordPage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyEvaluationEmployeeRecord/page',
    params
  })
}

//取企业考评待办提醒信息
export function companyEvaluationmessage(params) {
  return util.http({
    method: 'get',
    url: 'org/auth/companyEvaluation/message',
    params
  })
}

// 考评职工记录提交审核
export function companyEvaluationEmployeeRecordSubmitAudit(params) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyEvaluationEmployeeRecord/submitAudit',
    params
  })
}

// 审核
export function companyEvaluationEmployeeRecordAudit(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyEvaluationEmployeeRecord/audit',
    data
  })
}

// 考评职工记录修改
export function companyEvaluationEmployeeRecordPut(data) {
  return util.http({
    method: 'put',
    url: 'org/auth/companyEvaluationEmployeeRecord',
    data
  })
}
